import { render, staticRenderFns } from "./RiepilogoLavoriPerCliente.vue?vue&type=template&id=5dccccf2&scoped=true&"
import script from "./RiepilogoLavoriPerCliente.vue?vue&type=script&lang=js&"
export * from "./RiepilogoLavoriPerCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dccccf2",
  null
  
)

export default component.exports